import useSWRInfinite from 'swr/infinite';

// api
import { useState } from 'react';
import moment from 'moment';
import { SETTINGS } from '../constants';
import getCarriersAPICall from '../api/getCarriers';

// calls api to get tickets
const carriersFetcher = async (...args) => {
  return getCarriersAPICall(...args);
};

const getSearchQueryFromFilters = (filters) => {
  try {
    const { search } = filters;
    const isSearchValid = search.trim() !== '' && search.length > 0;
    if (!isSearchValid) return null;
    const query = `search=${search}`;
    return query;
  } catch (e) {
    return null;
  }
};

const getPageSizeQueryFromSettings = () => {
  const page_size = SETTINGS.CARRIERS_LIST_PAGE_SIZE;
  const query = `page_size=${page_size}`;
  return query;
};

const getCarriersQueryFromFilters = (filters) => {
  let query = ``;
  const pageSizeQuery = getPageSizeQueryFromSettings();
  const searchQuery = getSearchQueryFromFilters(filters);
  const queries = [pageSizeQuery, searchQuery];
  queries.forEach((currentQuery, index) => {
    if (!!currentQuery) {
      const paramSeparator = index === 0 ? '?' : '&';
      query = `${query}${paramSeparator}${currentQuery}`;
    }
  });
  return query;
};

// returns tickets with loading/reloading state
const useCarriersList = (props) => {
  const { selectedFilters } = props;
  const [lastUpdate, setLastUpdate] = useState(null);

  const getKey = (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData.length) return null; // reached the end
    const query = `${getCarriersQueryFromFilters(selectedFilters)}&page=${pageIndex + 1}`;
    return `carriers/${query}`;
  };

  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const {
    data: carriersData,
    error: carriersError,
    isValidating: isReloadingCarriers,
    size,
    setSize,
    mutate,
  } = useSWRInfinite(getKey, carriersFetcher, {
    refreshInterval: SETTINGS.RELOAD_CARRIERS_LIST_INTERVAL_IN_SECONDS * 1000,
    revalidateAll: true,
    revalidateIfStale: true,
    parallel: true,
    onSuccess: () => {
      const nowTime = moment().format('HH:mm:ss');
      setLastUpdate(nowTime);
      setIsLoadingMore(false);
    },
  });

  const isEmpty = carriersData?.[0]?.length === 0;
  const isReachingEnd =
    isEmpty ||
    (carriersData &&
      carriersData[carriersData.length - 1]?.length < SETTINGS.CARRIERS_LIST_PAGE_SIZE);

  const isLoadingCarriers = typeof carriersData === 'undefined';

  const loadMore = () => {
    setIsLoadingMore(true);
    return setSize(size + 1);
  };

  const reset = () => {
    mutate();
  };

  return {
    carriersData,
    isEmpty,
    isReachingEnd,
    isLoadingMore,
    lastUpdate,
    // first load
    isLoadingCarriers,
    // reloads
    isReloadingCarriers,
    carriersError,
    loadMore,
    reset,
  };
};

export default useCarriersList;
